import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_goldenbot.png",
      alt: "Estratégias GoldenBot",
    },
    title: "Tecnologia e estratégias para automatizar seus investimentos.",

    // String ou array de strings
    text: "Menos emoção e mais automação. Descubra como conciliar qualidade de vida com uma uma carteira saudável.",
    testimonial: {
      text: "Nossas estratégias são validadas na análise quantitativa de dados e principalmente em nossas contas reais, jamais iremos entregar estratégias sem antes testar em conta real e ser lucrativa.",
      author: {
        name: "Joel Machado, CEO GoldenBot",
        picture:
          "https://ontick-img.s3.sa-east-1.amazonaws.com/joel_goldenbot.jpeg",
      },
    },
  },
  stats: {
    title: "Saiba mais sobre a extensão GoldenBot",
    subtitle:
      "Veja o que você tem disponível através da extensão GoldenBot na OnTick Invest.",
    data: [
      {
        value: "5",
        description: "Estratégias prontas",
      },
      {
        value: "3",
        description: "Perfis de investidor",
      },
      {
        value: "2",
        description: "Ativos (WDO e WIN)",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da GoldenBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da GoldenBot.",
    data: [
      {
        icon: iconsSet.chip,
        title: "Alta tecnologia",
        description:
          "Operar com tecnologias que fazem análises profundas de milhares de dados em nanosegundos.",
      },
      {
        icon: iconsSet.test_tube,
        title: "Estudos avançados",
        description:
          "Atuar com base em análise quantitativa, em indicadores avançados analisando evidências empíricas consolidadas.",
      },
      {
        icon: iconsSet.paper_board,
        title: "Diversificação",
        description:
          "Empregar carteiras de múltiplas estratégias, com resultados médios superiores à estratégias isoladas.",
      },
      ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Nossa maior missão é unir você com",
    subtitle: "as melhores estratégias e tecnologias.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A GoldenBot",
    col1: [
      "Inconformado com os padrões baixos do mercado de day trade, Joel Farinácio fundou a GoldenBot para aliviar traders e investidores de erros e perdas geradas por fatores emocionais.",
      "A GoldenBot tem como característica uma brutal transparência e suas estratégias já atingiram os maiores resultados nos rankings internacionais de sinais, em especial nos quesitos performance e confiabilidade.",
    ],
    col2: [
      "Hoje propósito de te ajudar a colocar a tecnologia à serviço da sua liberdade.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão GoldenBot",
  },
  strategies: {
    title: "Estratégias GoldenBot",
    heading: "Estratégias automatizadas de day trade.",
    subtitle:
      "Carteiras com diversificação em diferentes estratégias e desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
  testimonials: [
    {
      text: "O resultado financeiro é muito bom, o robô possui bom gerenciamento de risco e costuma ter boa assertividade. Além disso, nos dá o luxo de ter ganhos bons no mercado sem precisar ficar na frente da tela o tempo todo.",
      author: "Flávio Alves de Rezende",
      job: "Cliente GoldenBot",
      image_url:
        "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Excelente! Quando usa-se um serviço que quase não há necessidade de suporte é sinal de que o serviço funciona muito bem. Por enquanto só tenho agradecer a GoldenBot, vamos em frente! Abraços",
      author: "David Souza",
      job: "Cliente GoldenBot",
      image_url:
        "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_goldenbot.png
